<template>
  <popup-model class="sightseeing_module" @close-model="$emit('onClose')" :closeBtn="false" :openModel="isNew">
    <div slot="content">
      <div class="model_title">{{ isUpdate ? "Update" : "Create" }} Sightseeing / Transfers</div>
      <hr class="my-2" />
      <div class="form_container">
        <div class="form-body">
          <div class="row gutter14">
            <div class="col-6">
              <div class="form-group mb-2" :class="{ invalid: $v.formData.service.$error }">
                <label class="mb-1 required">Service</label>
                <select @blur.prevent="$v.formData.service.$touch" :disabled="isUpdate" v-model.trim="formData.service" class="form-control">
                  <option value="">Choose</option>
                  <option value="sightseeing">Sightseeing</option>
                  <option value="transfers">Transfers</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2" :class="{ invalid: $v.formData.seat_type.$error }">
                <label class="mb-1 required">Seat Type</label>
                <select @blur.prevent="$v.formData.seat_type.$touch" v-model="formData.seat_type" class="form-control">
                  <option value="">Choose</option>
                  <option value="ticket">Ticket Only</option>
                  <option value="seat_in_coach">Seat In Coach</option>
                  <option value="private">Private</option>
                  <option value="value_packs">Value Packs</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2" :class="{ invalid: $v.formData.name.$error }">
                <label class="mb-1 required">Name</label>
                <input @blur.prevent="$v.formData.name.$touch" placeholder="Enter Name" v-model.trim="formData.name" type="text" class="form-control" />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2" :class="{ invalid: $v.formData.city.$error }">
                <label class="mb-1 required">City</label>
                <destSelector v-if="!isUpdate" :selectInput="true" @onSelectItem="onSelected" :selectedData="formData.city" :asyncData="getCityListByName" placeholder="Enter Name" />
                <span v-else class="form-control disabled">{{ formItem.city ? formItem.city.name : "" }}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2">
                <label class="mb-1">Image Url</label>
                <input v-model.trim="formData.image_url" type="text" class="form-control" placeholder="Enter image url" />
              </div>
            </div>
            <div class="col-6">
              <div class="row no-gutters">
                <div class="col-md-6">
                  <div class="form-group mr-2">
                    <label class="mb-1">Timing</label>
                    <select v-model="formData.timing" class="form-control mr-2">
                      <option value="">Choose</option>
                      <option value="day">All Day</option>
                      <option value="morning">Morning</option>
                      <option value="afternoon">Afternoon</option>
                      <option value="evening">Evening</option>
                      <option value="night">Night</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mr-2">
                    <label class="mb-1">Hours</label>
                    <input v-model.trim="hours" type="text" v-input-type="'number'" class="form-control mr-2" placeholder="Hours" />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="mb-1">Minutes</label>
                    <input v-model.trim="minutes" type="text" v-input-type="'number'" class="form-control mr-2" placeholder="Minutes" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <!-- <div v-if="formData.service == 'transfers'" class="row no-gutters">
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="d-flex align-items-center" style="font-weight: 600">
                  Price <span v-if="formData.seat_type == 'seat_in_coach'" class="fnt-11 clr-red font-bold ml-1">( The amount should be per person )</span>
                </label>
                <div class="mr-2">
                  <input v-input-type="'number'" type="text" v-model.trim="formData.pricing.adult" placeholder="Price" class="form-control form-control-sm mt-2" />
                </div>
              </div>
            </div>
          </div> -->
              <div v-if="formData.service == 'sightseeing'">
                <div v-if="formData.price_details && formData.price_details.length">
                  <p class="mb-2 font-bold fnt-14">Pricing (Seat type wise)</p>
                  <div class="row gutter14 mb-3" v-for="(sgt, index) in formData.price_details" :key="index">
                    <div class="col-md-12">
                      <div class="d-flex align-items-center">
                        <div class="font-bold mr-4">{{ bind_seat_type(sgt.type) }}</div>
                        <label class="d-flex align-items-center m-0"><input type="checkbox" v-model.trim="sgt.is_active" class="mr-2" /> Active </label>
                      </div>
                      <hr class="my-1" />
                    </div>
                    <div class="col-md-2">
                      <div class="form-group mb-0">
                        <label class="mb-1">Adult</label>
                        <input v-input-type="'number'" type="text" v-model.trim="sgt.adult" placeholder="Price" class="form-control form-control-sm" />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group mb-0">
                        <label class="d-flex align-items-center mb-1">
                          <input type="checkbox" class="mr-2" v-model.trim="sgt.cwb.is_cwb" />
                          Child (1)
                        </label>
                        <input type="text" v-model.trim="sgt.cwb.price" placeholder="Amount" class="form-control form-control-sm" />
                      </div>
                      <div class="row gutter14 mt-2">
                        <div class="col-7">
                          <div class="d-flex align-items-center">
                            <label for="" class="mb-0 mr-2">Age</label>
                            <select class="form-control form-control-sm" v-model="sgt.cwb.from" @blur="$v.formData.price_details.$each[index].cwb.from.$touch()">
                              <option value="">From</option>
                              <option v-for="date in (1, 12)" :key="date" :value="date">{{ date }}</option>
                            </select>
                          </div>
                          <small v-if="$v.formData.price_details.$each[index].cwb.from.$error" class="text-danger"> From age is required </small>
                        </div>
                        <div class="col-5">
                          <select class="form-control form-control-sm" v-model="sgt.cwb.to" @blur="$v.formData.price_details.$each[index].cwb.to.$touch()">
                            <option value="">To</option>
                            <option v-for="date in (1, 12)" :key="date" :value="date">{{ date }}</option>
                          </select>
                          <small v-if="$v.formData.price_details.$each[index].cwb.to.$error" class="text-danger"> To age is required </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group mb-0">
                        <label class="d-flex align-items-center mb-1">
                          <input type="checkbox" class="mr-2" v-model.trim="sgt.cnb.is_cnb" />
                          Child (2)
                        </label>
                        <input type="text" placeholder="Amount" class="form-control form-control-sm" v-model.trim="sgt.cnb.price" />
                      </div>
                      <div class="row gutter14 mt-2">
                        <div class="col-7">
                          <div class="d-flex align-items-center">
                            <label for="" class="mb-0 mr-2">Age</label>
                            <select class="form-control form-control-sm" v-model="sgt.cnb.from" @blur="$v.formData.price_details.$each[index].cnb.from.$touch()">
                              <option value="">From</option>
                              <option v-for="date in (1, 12)" :key="date" :value="date">{{ date }}</option>
                            </select>
                          </div>
                          <small v-if="$v.formData.price_details.$each[index].cnb.from.$error" class="text-danger"> From age is required </small>
                        </div>
                        <div class="col-5">
                          <select class="form-control form-control-sm" v-model="sgt.cnb.to" @blur="$v.formData.price_details.$each[index].cnb.to.$touch()">
                            <option value="">To</option>
                            <option v-for="date in (1, 12)" :key="date" :value="date">{{ date }}</option>
                          </select>
                          <small v-if="$v.formData.price_details.$each[index].cnb.to.$error" class="text-danger"> To age is required </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group mb-0">
                        <label class="d-flex align-items-center"><input type="checkbox" v-model.trim="sgt.is_infant" class="mr-2" /> Infant </label>
                        <input v-input-type="'number'" type="text" v-model.trim="sgt.infant" placeholder="Price" class="form-control form-control-sm" />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <hr class="my-2" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form_container" v-if="formData.service == 'transfers'">
                <div class="transfers">
                  <p class="font-bold fnt-14">Sharing Vehicle Price</p>
                  <div class="row no-gutters">
                    <div class="col-md-4">
                      <div class="form-group mb-0">
                        <label class="d-flex align-items-center" style="font-weight: 600"> Price <span class="fnt-11 clr-red font-bold ml-1">( The amount should be per seat )</span> </label>
                        <div class="mr-2">
                          <input v-input-type="'number'" type="text" v-model.trim="formData.sharing.price" placeholder="Price" class="form-control form-control-sm mt-2" />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group mb-0">
                        <label class="d-flex align-items-center" style="font-weight: 600"> Child Age </label>
                        <div class="mr-2">
                          <input v-input-type="'number'" type="text" v-model.trim="formData.sharing.child_age" placeholder="child age" class="form-control form-control-sm mt-2" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="transfers" v-if="formData.service == 'transfers'">
                <p class="font-bold fnt-14">Vehicle Categories Prices</p>
                <div class="services">
                  <label v-for="(item, v_index) in vehicle_category" :key="v_index" class="services_label" @click.prevent="select_transfers(item)">
                    <input type="checkbox" class="services_checkbox" :checked="item.is_include" readonly />
                    <span class="services_span">{{ item.name }}</span>
                  </label>
                </div>

                <div v-if="transfer_data.length">
                  <div v-for="(_item, t_index) in transfer_data" :key="t_index">
                    <div class="row gutter14 mb-3">
                      <div class="col-md-12">
                        <div class="d-flex align-items-center">
                          <div class="font-bold mr-4">
                            Category <span style="color: red">( {{ bind_vehicle_type(_item.type) }} )</span>
                          </div>
                          <label class="d-flex align-items-center m-0"><input type="checkbox" class="mr-2" v-model="_item.is_active" /> Active </label>
                          <label class="d-flex align-items-center m-0 ml-2"><input type="checkbox" class="mr-2" v-model="_item.is_non_ac" />Non-Ac </label>
                          <label class="d-flex align-items-center m-0 ml-2"><input type="checkbox" class="mr-2" v-model="_item.is_child_allow" />Child Allowed </label>
                        </div>
                        <hr class="my-1" />
                      </div>

                      <div class="col-md-4">
                        <div class="form-group" :class="{ invalid: $v.transfer_data.$each[t_index].vehicle.$error }">
                          <label class="d-flex align-items-center font-bold">Vehicle</label>
                          <input type="text" placeholder="Vehicle" class="form-control form-control-sm" v-model="_item.vehicle" @blur="$v.transfer_data.$each[t_index].vehicle.$touch()" />
                        </div>
                        <!-- <small v-if="$v.transfer_data.$each[t_index].vehicle.$error" class="text-danger"> vehicle name is required </small> -->
                      </div>
                      <div class="col-md">
                        <div class="form-group mb-0" :class="{ invalid: $v.transfer_data.$each[t_index].price.$error }">
                          <label class="d-flex align-items-center font-bold">Price<span class="text-danger">*</span></label>
                          <input
                            type="text"
                            v-input-type="'number'"
                            placeholder="Price"
                            class="form-control form-control-sm"
                            v-model="_item.price"
                            @blur="$v.transfer_data.$each[t_index].price.$touch()"
                          />
                          <!-- <small v-if="$v.transfer_data.$each[t_index].price.$error" class="text-danger"> price is required </small> -->
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group mb-0" :class="{ invalid: $v.transfer_data.$each[t_index].max_occupancy.$error }">
                          <label class="d-flex align-items-center font-bold font-bold">Max Pax<span class="text-danger">*</span></label>
                          <input
                            type="text"
                            v-input-type="'number'"
                            placeholder="Max occupancy"
                            class="form-control form-control-sm"
                            v-model="_item.max_occupancy"
                            @blur="$v.transfer_data.$each[t_index].max_occupancy.$touch()"
                          />
                          <!-- <small v-if="$v.transfer_data.$each[t_index].max_occupancy.$error" class="text-danger"> Occupancy is required </small> -->
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group mb-0" :class="{ invalid: $v.transfer_data.$each[t_index].child_age.$error }">
                          <label class="d-flex align-items-center font-bold">Child Age<span class="text-danger">*</span></label>
                          <input
                            type="text"
                            v-input-type="'number'"
                            placeholder="child Age"
                            class="form-control form-control-sm"
                            v-model="_item.child_age"
                            @blur="$v.transfer_data.$each[t_index].child_age.$touch()"
                          />
                          <!-- <small v-if="$v.transfer_data.$each[t_index].child_age.$error" class="text-danger"> child age is required </small> -->
                        </div>
                      </div>
                      <!-- :class="{ invalid: $v.transfer_data.$each[t_index].surcharge.$error }"
                      @blur="$v.transfer_data.$each[t_index].surcharge.$touch()"
                      <span class="text-danger">*</span> -->
                      <div class="col-md">
                        <div class="form-group mb-0">
                          <label class="d-flex align-items-center font-bold">Surcharge</label>
                          <input v-input-type="'number'" type="text" placeholder="surcharge" class="form-control form-control-sm" v-model="_item.surcharge" />
                          <!-- <small v-if="$v.transfer_data.$each[t_index].surcharge.$error" class="text-danger"> surcharge is required </small> -->
                        </div>
                      </div>
                      <!-- :class="{ invalid: $v.transfer_data.$each[t_index].timing.$error }"
                      <span class="text-danger">*</span>
                      @blur="$v.transfer_data.$each[t_index].timing.$touch()" -->
                      <div class="col-md">
                        <div class="form-group mb-0">
                          <label class="d-flex align-items-center font-bold">Timing</label>
                          <input type="text" placeholder="timing" class="form-control form-control-sm" v-model="_item.timing" />
                          <!-- <small v-if="$v.transfer_data.$each[t_index].timing.$error" class="text-danger"> timing is required </small> -->
                        </div>
                      </div>
                    </div>
                    <hr class="my-2" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group mb-0">
                <label class="mb-1">Description</label>
                <vue-editor class="sightseeing_description" :editor-toolbar="toolbarSettings" v-model.trim="formData.description" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_container">
        <label class="title">Pricing</label>
        <div v-if="formData.service == 'transfers'" class="row no-gutters">
          <div class="col-md-4">
            <div class="form-group mb-0">
              <label class="d-flex align-items-center" style="font-weight: 600">
                Price <span v-if="formData.seat_type == 'seat_in_coach'" class="fnt-11 clr-red font-bold ml-1">( The amount should be per person )</span>
              </label>
              <div class="mr-2">
                <input v-input-type="'number'" type="text" v-model.trim="formData.pricing.adult" placeholder="Price" class="form-control form-control-sm mt-2" />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row no-gutters">
          <div class="col-md-4">
            <div class="form-group mb-0">
              <label class="d-flex">Adult</label>
              <div class="mr-2">
                <input v-input-type="'number'" type="text" v-model.trim="formData.pricing.adult" placeholder="Price" class="form-control form-control-sm mt-2" />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-0">
              <label class="d-flex align-items-center">Child <input type="checkbox" v-model.trim="formData.pricing.is_child" class="ml-2" /></label>
              <div class="mr-2">
                <input v-input-type="'number'" type="text" v-model.trim="formData.pricing.child" placeholder="Price" :disabled="!formData.pricing.is_child" class="form-control form-control-sm mt-2" />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-0">
              <label class="d-flex align-items-center">Infant <input type="checkbox" v-model.trim="formData.pricing.is_infant" class="ml-2" /></label>
              <div>
                <input
                  v-input-type="'number'"
                  type="text"
                  v-model.trim="formData.pricing.infant"
                  placeholder="Price"
                  :disabled="!formData.pricing.is_infant"
                  class="form-control form-control-sm mt-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form_container">
        <div class="d-flex justify-content-end mt-2">
          <button @click.prevent="handleSubmitSightForm" href="javascript:void(0)" class="btn btn-info mr-2">{{ isUpdate ? "Update" : "Save" }}</button>
          <button @click.prevent="$emit('onClose')" href="javascript:void(0)" class="btn btn-danger">Cancel</button>
        </div>
      </div>
    </div>
  </popup-model>
</template>

<script>
import destSelector from "../create/components/basic/dest-selector.vue";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
const _price_details = [
  {
    type: "ticket",
    adult: "",
    is_child: false,
    child: "",
    is_infant: false,
    infant: "",
    is_active: false,
    cwb: { price: "", is_cwb: false, from: "", to: "" },
    cnb: { price: "", is_cnb: false, from: "", to: "" }
  },
  {
    type: "seat_in_coach",
    adult: "",
    is_child: false,
    child: "",
    is_infant: false,
    infant: "",
    is_active: false,
    cwb: { price: "", is_cwb: false, from: "", to: "" },
    cnb: { price: "", is_cnb: false, from: "", to: "" }
  },
  {
    type: "private",
    adult: "",
    is_child: false,
    child: "",
    is_infant: false,
    infant: "",
    is_active: false,
    cwb: { price: "", is_cwb: false, from: "", to: "" },
    cnb: { price: "", is_cnb: false, from: "", to: "" }
  },
  {
    type: "value_packs",
    adult: "",
    is_child: false,
    child: "",
    is_infant: false,
    infant: "",
    is_active: false,
    cwb: { price: "", is_cwb: false, from: "", to: "" },
    cnb: { price: "", is_cnb: false, from: "", to: "" }
  }
];
const vehicle_category = [
  { name: "Sedan", key: "sedan", is_include: false },
  { name: "SUV", key: "suv", is_include: false },
  { name: "MUV", key: "muv", is_include: false },
  { name: "Luxury Sedan", key: "luxury-sedan", is_include: false },
  { name: "Luxury SUV", key: "luxury-suv", is_include: false },
  { name: "Van/Minivan", key: "van-minivan", is_include: false },
  { name: "Mini Coach", key: "mini-coach", is_include: false },
  { name: "Coach/Bus", key: "coach-bus", is_include: false },
  { name: "Hatchback", key: "hatch-back", is_include: false }
];
export default {
  name: "InsertSightseeing",
  components: {
    destSelector
  },
  props: {
    isNew: { type: Boolean, default: false },
    isUpdate: { type: Boolean, default: false },
    formItem: { type: Object }
  },
  data() {
    return {
      hours: "",
      minutes: "",
      formData: {
        name: "",
        city: {},
        service: "",
        seat_type: "",
        description: "",
        image_url: "",
        duration: "",
        timing: "",
        pricing: {
          adult: "",
          is_child: false,
          child: "",
          is_infant: false,
          infant: ""
        },
        price_details: _price_details,
        sharing: {
          price: "",
          child_age: ""
        }
      },
      toolbarSettings: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ header: 1 }, { header: 2 }],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }]
      ],
      vehicle_category: vehicle_category,
      transfer_data: []
    };
  },
  validations: {
    formData: {
      service: { required },
      seat_type: { required },
      name: { required },
      city: { required },
      price_details: {
        $each: {
          cwb: {
            from: {
              required(value, parent) {
                return !parent.is_cwb || required(value);
              }
            },
            to: {
              required(value, parent) {
                return !parent.is_cwb || required(value);
              }
            }
          },
          cnb: {
            from: {
              required(value, parent) {
                return !parent.is_cnb || required(value);
              }
            },
            to: {
              required(value, parent) {
                return !parent.is_cnb || required(value);
              }
            }
          }
        }
      }
    },
    transfer_data: {
      $each: {
        vehicle: { required },
        price: { required },
        max_occupancy: { required },
        child_age: { required }
        // surcharge: { required },
        // timing: { required }
      }
    }
  },
  watch: {
    formItem(value) {
      if (this._.isEmpty(value)) {
        this.formData = {
          name: "",
          city: {},
          description: "",
          image_url: "",
          service: "",
          seat_type: "",
          duration: "",
          timing: "",
          pricing: { adult: "", is_child: false, child: "", is_infant: false, infant: "" },
          price_details: JSON.parse(JSON.stringify(_price_details)),
          sharing: {
            price: "",
            child_age: ""
          }
        };
      } else {
        this.formData = value;
        if (this?.isUpdate) {
          this.transfer_data = value?.vehicle_prices || [];
          const _includes = value?.vehicle_prices?.filter((val) => val.is_include);
          if (_includes?.length) {
            for (let item of _includes) {
              const _index = this?.vehicle_category?.findIndex((val) => val.key == item?.type);
              if (_index != -1) this.vehicle_category[_index].is_include = true;
            }
          }
        }
        if (value.duration) {
          const _hour = value.duration?.split(" hr")[0];
          const _minutes = +_hour ? value.duration.split(" hr")[1]?.split(" mins")[0] : value.duration?.split(" mins")[0];
          if (+_hour) this.hours = +_hour;
          if (+_minutes) this.minutes = +_minutes;
        }
      }
      this.$v.$reset();
    },
    hours(value) {
      let _text = value > 0 ? value + " hr" : "";
      if (this.minutes > 0) _text += " " + this.minutes + " mins";
      this.formData.duration = _text;
    },
    minutes(value) {
      let _text = value > 0 ? value + " mins" : "";
      if (this.hours > 0) _text = this.hours + " hr " + _text;
      this.formData.duration = _text;
    },
    isNew(value) {
      if (!value) {
        this.formData = {
          name: "",
          city: {},
          description: "",
          image_url: "",
          duration: "",
          service: "",
          seat_type: "",
          timing: "",
          pricing: { adult: "", is_child: false, child: "", is_infant: false, infant: "" },
          price_details: JSON.parse(JSON.stringify(_price_details))
        };
        this.transfer_data = [];
        this.vehicle_category = this?.vehicle_category?.map((val) => ({ ...val, is_include: false }));
        this.$emit("onClose");
        this.$v.$reset();
      }
    },
    "formData.pricing.is_child": function (value) {
      if (!value) this.formData.pricing.child = "";
    },
    "formData.pricing.is_infant": function (value) {
      if (!value) this.formData.pricing.infant = "";
    }
  },
  methods: {
    ...mapActions(["createPackageSightseeing", "getCityListByName"]),
    onSelected(value) {
      this.formData.city = { ...value, name: value.destinationName };
    },
    handleSubmitSightForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this?.transfer_data?.length) this.formData = { ...this.formData, vehicle_prices: this?.transfer_data };
        this.createPackageSightseeing({ ...this.formData, city: this.formData.city.id }).then((data) => {
          this.formData.price_details = JSON.parse(JSON.stringify(_price_details));
          this.transfer_data = [];
          this.formData.city = {};
          this.hours = "";
          this.minutes = "";
          this.$emit("onClose");
        });
      }
    },
    bind_seat_type(type) {
      if (type == "ticket") return "Ticket Only";
      if (type == "seat_in_coach") return "Seat In Coach";
      if (type == "private") return "Private";
      if (type == "value_packs") return "Value Packs";
      return "N/A";
    },
    select_transfers(item) {
      item.is_include = !item.is_include;
      if (item?.is_include) {
        this.transfer_data.push({ type: item?.key, vehicle: "", is_include: item?.is_include, price: "", max_occupancy: "", child_age: "", surcharge: "", timing: "", is_active: true });
      } else {
        const _index = this?.transfer_data?.findIndex((val) => val.type == item?.key);
        if (_index != -1) this?.transfer_data?.splice(_index, 1);
      }
    },
    bind_vehicle_type(type) {
      let _item = this.vehicle_category?.find((val) => val?.key == type);
      if (_item) return _item?.name;
    }
  }
};
</script>

<style scoped>
.sightseeing_module >>> .popup_body {
  border-radius: 0;
  /* max-height: fit-content; */
  /* width: 650px; */
  max-height: 600px;
  padding: 0;
}

.sightseeing_module >>> .model_title {
  font-size: 16px;
  font-weight: 600;
  padding: 4px 10px 0px 10px;
}

.sightseeing_module >>> .form_container {
  padding: 0px 10px 10px 10px;
}

.sightseeing_module >>> .form_container:not(:last-child) {
  border-bottom: 1px solid #e6e6e6;
  margin-top: 5px;
  padding-bottom: 10px;
}

.sightseeing_module >>> .form_container > .title {
  font-weight: 600;
  font-size: 14px;
}

.sightseeing_module >>> .form_container button {
  width: 75px;
  border-radius: 0px;
  font-size: 12px;
  height: 26px;
  line-height: 5px;
}

.form-control.disabled {
  background-color: #e6e6e6;
}

.sightseeing_description >>> .ql-editor {
  min-height: 140px;
}
.services {
  margin: 10px 0;
  user-select: none;
}

.services_label {
  display: inline-block;
  margin: 0 8px 10px 0;
  cursor: pointer;
  user-select: none;
}

.services_checkbox {
  display: none;
}

.services_span {
  display: inline-block;
  border-radius: 50px;
  padding: 4px 20px;
  background: transparent;
  border: 1px solid #17a2b8;
  color: #17a2b8;
}

.services_checkbox:checked ~ .services_span {
  background: #17a2b8;
  color: #fff;
}

.service-details,
.package-options {
  margin: 15px 0;
  background: #fff;
  color: #8f8f8f;
  padding: 15px;
  border-bottom: 1px solid #d7d7d7;
}

.transfers >>> .form-group {
  margin-bottom: 0.5rem;
}
</style>
